import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CucumberService } from 'src/app/Services/cucumber.service';
import { SuiteService } from 'src/app/Services/suite.service';
import { ListInterface } from 'src/app/Inteface/list-interface';
import { SuiteModel } from 'src/app/Models/suite-model';

@Component({
  selector: 'ze-suite-canvas-dialog',
  templateUrl: './suite-canvas-dialog.component.html',
  styleUrls: ['./suite-canvas-dialog.component.scss']
})
export class SuiteCanvasDialogComponent implements OnInit {

  tabsList: ListInterface[] = [];
  loading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { suiteId: string; suiteName: string },
    private dialogRef: MatDialogRef<SuiteCanvasDialogComponent>,
    private cucumberService: CucumberService,
    private suiteService: SuiteService
  ) {}

  ngOnInit(): void {
    this.suiteService.getItemsdb2().subscribe(suiteData => {
      const allSuites: SuiteModel[] = suiteData['data'].filter(Boolean);
      const targetSuite = allSuites.find(s => s['_id'] === this.data.suiteId);
      if (!targetSuite) { this.loading = false; return; }
      const li = new ListInterface();
      li.mainHeadingName = (targetSuite as any).name;
      li._id = (targetSuite as any)._id;
      li._type = (targetSuite as any)._type;
      li.modelService = this.suiteService;
      li.models = [];
      this.cucumberService.getSuiteCucumberdb2(this.data.suiteId).subscribe({
        next: (cucumberData) => {
          if (cucumberData && cucumberData.data) { li['model'] = cucumberData.data; }
          this.tabsList = [li];
          this.loading = false;
        },
        error: () => { this.tabsList = [li]; this.loading = false; }
      });
    }, () => { this.loading = false; });
  }

  close(): void { this.dialogRef.close(); }
  onTabRemoved(index: number) { this.tabsList.splice(index, 1); }
  onIndexSelected(_: number) {}
  onCanvas(_: any) {}
  onDelete(_: any) {}
}